import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { toast } from 'react-toastify';
import { ROOT_URL } from '../../api/ApiConfig';

// Async thunk to fetch articles by category slug
export const getExternalKbSettings = createAsyncThunk(
  'kbCategory/getExternalKbSettings',
  async ({ businessName, group_id }, { rejectWithValue }) => {
    try {
      if (!businessName) {
        throw new Error('Missing businessName');
      }
      if (!group_id) {
        throw new Error('Missing group_id');
      }

      const url = `${ROOT_URL}/kb/settings/external/${businessName}`;

      const response = await axios.get(url, {
        headers: {
          // Add authorization header if your API requires it
          // 'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        params: { group_id },
      });

      // Assuming the API returns something like:
      // { status: 200, message: "...", data: { category: {...}, articles: [...] } }
      return response.data;
    } catch (error) {
      console.error('Error fetching articles by category:', error);

      const errorMessage =
        error.response?.data?.message ||
        error.message ||
        'Failed to fetch articles for this category';

      return rejectWithValue(errorMessage);
    }
  }
);

const initialState = {
  loading: true,
  success: false,
  error: null,
  data: null,
  initialized: false, // ✅ tracks if API was ever called
};

const getExternalKbSettingsSlice = createSlice({
  name: 'getExternalKbSettings',
  initialState,
  reducers: {
    resetGetExternalKbSettingsState: (state) => {
      state.loading = false;
      state.success = false;
      state.error = null;
      state.data = null;
      state.initialized = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getExternalKbSettings.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = false;
        state.initialized = false;
      })
      .addCase(getExternalKbSettings.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.data = action.payload;
        state.error = null;
        state.initialized = true; // ✅ API done successfully
      })
      .addCase(getExternalKbSettings.rejected, (state, action) => {
        state.loading = false;
        state.success = false;
        state.error = action.payload;
        state.data = null;
        state.initialized = true; // ✅ API done even if failed
        // toast.error(action.payload || 'Failed to load articles');
      });
  },
});

export const { resetGetExternalKbSettingsState } = getExternalKbSettingsSlice.actions;
export default getExternalKbSettingsSlice.reducer;